module.exports = __webpack_public_path__ + "static/media/November_2026_3.dea883e2.webp";